import { alpha } from "@mui/material/styles";
import { Theme } from "@mui/material";

export const getFormSectionStyles = (theme: Theme) => {
  const isDark = theme.palette.mode === "dark";
  const accent = theme.palette.status.accent;
  const cardBg = isDark ? theme.palette.background.paper : theme.palette.common.white;
  const cardBorder = isDark
    ? alpha(theme.palette.common.white, 0.14)
    : alpha(theme.palette.common.black, 0.12);
  const railBg = alpha(accent, isDark ? 0.12 : 0.05);
  const railBorder = alpha(accent, isDark ? 0.75 : 0.85);

  return {
    accent,
    paper: {
      p: 3,
      borderRadius: 2,
      backgroundColor: cardBg,
      border: `1px solid ${cardBorder}`,
      boxShadow: isDark
        ? `0 1px 0 ${alpha(theme.palette.common.white, 0.06)}`
        : `0 1px 2px ${alpha(theme.palette.common.black, 0.08)}`,
    },
    title: {
      mb: 2,
      fontWeight: 600,
      color: accent,
      letterSpacing: 0.2,
    },
    checkbox: {
      color: theme.palette.text.secondary,
      "&.Mui-checked": { color: accent },
      "&:hover": { backgroundColor: alpha(accent, 0.08) },
    },
    switch: {
      "& .MuiSwitch-track": {
        backgroundColor: alpha(theme.palette.text.primary, isDark ? 0.35 : 0.25),
      },
      "& .MuiSwitch-switchBase.Mui-checked": { color: accent },
      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: accent,
      },
    },
    nestedSection: {
      p: 2,
      mb: 3,
      borderLeft: `3px solid ${railBorder}`,
      borderRadius: 1,
      backgroundColor: railBg,
    },
    collapsibleRail: {
      pl: 3,
      borderLeft: `2px solid ${railBorder}`,
      backgroundColor: railBg,
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6,
      mt: 1,
      ml: 0.5,
      mb: 3,
    },
  };
};
